import { asyncComponentFactory } from '@utils';

const AppComponents = {
  // UI Components ------------------------------------------------------------
  Drawer: asyncComponentFactory('ui/Drawer'),
  Modal: asyncComponentFactory('ui/Modal'),
  MediaPlayer: asyncComponentFactory('ui/MediaPlayer'),
  Slider: asyncComponentFactory('ui/Slider'),
  Accordion: asyncComponentFactory('ui/Accordion'),
  // MEDIA Components ------------------------------------------------------------

  // NAV Components ------------------------------------------------------------

  // PRODUCT Components ------------------------------------------------------------

};

export default AppComponents;
